import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails,
   // CognitoUserAttribute
} from 'amazon-cognito-identity-js'
import { CognitoIdentityCredentials, config } from 'aws-sdk'
import awsConfig from './../config'
import store from './../store'



export default class Cognito {
    configure(configure) {
        if (configure.userPool) {
            this.userPool = configure.userPool
        } else {
            this.userPool = new CognitoUserPool({
                UserPoolId: configure.UserPoolId,
                ClientId: configure.ClientId,
                Storage: sessionStorage
            })
        }

        config.region = configure.Region

        this.options = configure
        this.currentUser = false
    }

    static install = (Vue, options) => {
        Object.defineProperty(Vue.prototype, '$cognito', {
            get() { return this.$root._cognito }
        })


        Vue.mixin({
            beforeCreate() {
                if (this.$options.cognito) {
                    this._cognito = this.$options.cognito
                    this._cognito.configure(options)
                }
            }
        })
    }

    //���[�U�̃O���[�v��ύX����
    changeGroup(username, userclass, flg) {
        const AWS = require('aws-sdk')
        //const credential = awsConfig.AWSConfig.Credential//eslint-disable-line

        AWS.config.update({ region: awsConfig.AWSConfig.Region })

        AWS.config.credentials = new CognitoIdentityCredentials({
            IdentityPoolId: awsConfig.AWSConfig.IdentityPoolId,
            Logins: {
                //�J����
                //'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_Y7ke3tUPf': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
                //���؊�
                //'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_YmdlZP3d0': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
                //�{�Ԋ�
                'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_nVYZD7GXt': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
                //�ێ��
                //'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_VdbTsi5r8': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
            },
            Storage: sessionStorage

        })
        //���[�U���
        var params = {
            UserPoolId: awsConfig.AWSConfig.UserPoolId,
            Username: username,
            GroupName: "admin"
        };

        var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({});

        if (flg == 0) {//�O���[�v�ւ̒ǉ�
            return new Promise((resolve, reject) => {
                if (userclass == 1 || userclass == 2) {
                    cognitoidentityserviceprovider.adminAddUserToGroup(params, (err, result) => {
                        AWS.config.credentials.clearCachedId()
                        if (err) {
                            reject(err)
                        }
                        else {
                            resolve(result)
                        }
                    })
                } else {
                    resolve("��ʃ��[�U")
                }

            })
        } else if (flg == 1) {
            return new Promise((resolve, reject) => {
                if (userclass == 1 || userclass == 2) {
                    cognitoidentityserviceprovider.adminAddUserToGroup(params, (err, result) => {
                        AWS.config.credentials.clearCachedId()
                        if (err) {
                            reject(err)
                        }
                        else {
                            resolve(result)
                        }
                    })
                } else {
                    cognitoidentityserviceprovider.adminRemoveUserFromGroup(params, (err, result) => {
                        AWS.config.credentials.clearCachedId()
                        if (err) {
                            reject(err)
                        }
                        else {
                            resolve(result)
                        }
                    })
                }
            })
        }
    }

    //�T�C���A�b�v
    signUp(username, email,flg,tmpPassword) {
        const AWS = require('aws-sdk')
        
        console.log(password)
        AWS.config.update({ region: awsConfig.AWSConfig.Region })

        AWS.config.credentials = new CognitoIdentityCredentials({
            IdentityPoolId: awsConfig.AWSConfig.IdentityPoolId,
            Logins: {
                //�J����
                //'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_Y7ke3tUPf': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
                //���؊�
                //'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_YmdlZP3d0': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
                //�{�Ԋ�
                'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_nVYZD7GXt': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
                //�ێ��
                //'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_VdbTsi5r8': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
            },
            Storage: sessionStorage

        })


        var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({});

        //console.log(this.currentUser.username)
        var params
        var password
        if (tmpPassword == null) {
            password = this.makePassword();
        }
        else
        {
            password = tmpPassword;
        }

        if (flg == 1) {
            //���[�U���
            params = {
                UserPoolId: awsConfig.AWSConfig.UserPoolId,
                Username: username,
                DesiredDeliveryMediums: [                   //���҃��b�Z�[�W
                    'EMAIL'
                ],
                TemporaryPassword: password,          //�ݒ肵�Ȃ���Ύ����Ő���        
                UserAttributes: [
                    {
                        Name: 'email',
                        Value: email
                    },
                    {
                        Name: 'name',
                        Value: username
                    },
                    {
                        Name: 'email_verified',
                        Value: 'true'
                    }
                ]
            };

            return new Promise((resolve, reject) => {
                cognitoidentityserviceprovider.adminCreateUser(params, (err, result) => {
                    AWS.config.credentials.clearCachedId()
                    if (err) {
                        reject(err)
                    }
                    else {
                        resolve(result.User.Attributes[0].Value)
                    }
                })

            })

            //return new Promise((resolve, reject) => {
            //    if (username == '00000000') {
            //        console.log(email)
            //        reject('AccessDeniedException')//���[�U�̍쐬�Ɏ��s
            //    } else {
            //        resolve("xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx")//���[�U�̍쐬�ɐ���
            //    }
            //})

        } else if (flg == 2) {
             params = {
                 UserPoolId: awsConfig.AWSConfig.UserPoolId,
                Username: username,
                UserAttributes: [
                    {
                        Name: 'email',
                        Value: email
                    },
                    {
                        Name: 'email_verified',
                        Value: 'true'
                    }
                ]
            };
            return new Promise((resolve, reject) => {
                cognitoidentityserviceprovider.adminUpdateUserAttributes(params, (err, result) => {
                    AWS.config.credentials.clearCachedId()
                    if (err) {
                        reject(err)
                    }
                    else {
                        resolve(result)
                    }
                })

            })
        }

        
        
    }

    //�Ǘ��҂ɂ�郆�[�U�̍폜
    deleteUser(username) {
        const AWS = require('aws-sdk')
        //const credential = awsConfig.AWSConfig.Credential//eslint-disable-line

        AWS.config.update({ region: awsConfig.AWSConfig.Region })

        //���[�U���
        var params = {
            UserPoolId: awsConfig.AWSConfig.UserPoolId,
            Username: username,
        };

        AWS.config.credentials = new CognitoIdentityCredentials({
            IdentityPoolId: awsConfig.AWSConfig.IdentityPoolId,
            Logins: {
                //�J����
                //'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_Y7ke3tUPf': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
                //���؊�
                //'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_YmdlZP3d0': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
                //�{�Ԋ�
                'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_nVYZD7GXt': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
                //�ێ��
                //'cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_VdbTsi5r8': sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")
            },
            Storage: sessionStorage

        })


        var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({});

        return new Promise((resolve, reject) => {
            cognitoidentityserviceprovider.adminDeleteUser(params, (err, result) => {
                AWS.config.credentials.clearCachedId()
                if (err) {
                    reject(err)
                }
                else {
                    resolve(result)
                }
            })

        })

        //return new Promise((resolve, reject) => {
        //    if (username == '00000000') {
        //        reject(0)//���[�U�̍폜�Ɏ��s
        //    } else {
        //        resolve(1)//���[�U�̍폜�ɐ���
        //    }
        //})
    }


    //�����_���ȃp�X���[�h�𐶐�
    makePassword() {
        const source = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_?!#$%&'
        const sLetter = /^(?=.*[a-z])/
        const lLetter = /^(?=.*[A-Z])/
        const num = /^(?=.*[0-9])/
        const symbol = /^(?=.*[_?!#$%&])/
        const length = 8
        var result = ''

        while (length == 8 ) {
            result = ''
            for (var i = 0; i < length; i++) {
                result += source.charAt(Math.floor(Math.random()*source.length))
            }
            if (sLetter.test(result) && lLetter.test(result) && num.test(result) && symbol.test(result)) {
                break
            }
        }

        return result
    }

    

     //�T�C���C��
    signin(username, password) {
        const userData = { Username: username, Pool: this.userPool ,Storage:sessionStorage}
        const cognitoUser = new CognitoUser(userData)
        const authenticationData = { Username: username, Password: password }
        const authenticationDetails = new AuthenticationDetails(authenticationData)
        return new Promise((resolve, reject) => {
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: (result) => {
                    resolve(result)
                },
                onFailure: (err) => {
                    reject(err)
                },
                newPasswordRequired: function () {
                    cognitoUser.completeNewPasswordChallenge(password, {}, this)
                }
            })
        })
    }

 

    // �T�C���A�E�g
    signout() {
        if(this.userPool.getCurrentUser()) {
            this.userPool.getCurrentUser().signOut()
        }
    }
    

    // �F�؂��݂��ǂ���
    isAuthenticated() {
        this.currentUser = this.userPool.getCurrentUser()
        return new Promise((resolve, reject) => {
            if (this.currentUser === null) { reject(this.currentUser) }
            this.currentUser.getSession((err, session) => {
                if (err) {
                    reject(err)
                } else {
                    if (!session.isValid()) {
                        console.log('00 isauthen')
                        reject(session)
                    } else {
                        console.log('00 isauthen')
                        resolve(session)
                    }
                }
            })
            
        })
    }

    // �p�X���[�h�X�V
    updatePassword(oldPassword, newPassword) {
        return new Promise((resolve, reject) => {
            this.currentUser.changePassword(oldPassword, newPassword, (err, result) => {
                if (err) {
                    console.log(oldPassword)
                    console.log(newPassword)
                    reject(err)
                }
                else {
                    resolve(result)
                }
            })
        })
    }

    // �p�X���[�h�Y�ꃁ�[�����M
    forgetPassword(username) {
        const userData = { Username: username, Pool: this.userPool }
        const cognitoUser = new CognitoUser(userData)
        return new Promise((resolve, reject) => {
            cognitoUser.forgotPassword({
                onSuccess: (result) => {
                    console.log('email verification success')
                    resolve(result)
                },
                onFailure: (err) => {
                    console.log('email verification failed')
                    reject(err)
                }
            })
        })
    }

    // �p�X���[�h���Z�b�g
    resetPassword(username, newPassword, code) {
        const userData = { Username: username, Pool: this.userPool }
        const cognitoUser = new CognitoUser(userData)
        return new Promise((resolve, reject) => {
            cognitoUser.confirmPassword(code, newPassword, {
                onSuccess: (result) => {
                    console.log('password reset success')
                    resolve(result)
                },
                onFailure: (err) => {
                    console.log('password reset failed')
                    reject(err)
                }
            })
        })
    }

    //���[���A�h���X�ύX
    updateEmailAddress(email) {
        var attributes = {
            Name: 'email',
            Value: email
        }
        var attributeList = []
        attributeList.push(attributes)

        return new Promise((resolve, reject) => {
            this.currentUser.updateAttributes(attributeList, (err, result) => {
                if (err) {
                    reject(err)
                } else {
                    resolve(result)
                }
            })
        })
    }

    //���[���A�h���X����
    verifyAttribute(confirmationCode) {
        return new Promise((resolve, reject) => {
            this.currentUser.verifyAttribute("email", confirmationCode, {
                onSuccess: (result) => {
                    console.log('email verification success')
                    resolve(result)
                },
                onFailure: (err) => {
                    console.log('email verification failed')
                    reject(err)
                }
            })
        })
    }

}